import React, { useEffect, useMemo, useState } from "react";
import { Box, Select, Typography, Option, Autocomplete, AutocompleteOption, ListItemContent } from "@mui/joy";

import { capitalizeWords, formatNoteName } from "../../utils/FormatNoteNameAndText";
import { NoteSections, PrivateMapping } from "../../utils/constants/Notes";
import PropTypes from "prop-types";
import { getEmail } from "../../services/Authentication";

function giveNoteOptions(email, sections, defaultValue) {
    // {label: "", id: "", section: ""}
    const availableOptions = []
    let defaultNote;

    Object.entries(PrivateMapping).map(([section, notes]) => {
        if (!email || email === "null") {
            return;
        }

        if (PrivateMapping.private_notes_by_email(email).includes(section)) {
            notes.map((note) => {
                availableOptions.push({label: formatNoteName(note), id: note, section: capitalizeWords(section, "_")})
                if(defaultValue === note) {
                    defaultNote = note;
                }
            })
        }
    })

    Object.entries(NoteSections).map(([section, notes]) => {
        if (!sections.includes(section)) {
            // If not in the list, skip rendering or return null
            return;
        }

        notes.map((note) => {
            availableOptions.push({label: formatNoteName(note), id: note, section: capitalizeWords(section, "_")})
            if(defaultValue === note) {
                defaultNote = note;
            }
        })
    })

    return {
        "options": availableOptions,
        "default": defaultNote ? formatNoteName(defaultNote) : availableOptions[0]["label"],
    };
}

export function NoteTypeSelect({onChange, value, disabled, sx, calmTitle, noteViews, ...rest}) {
    const [ allOptions, setAllOptions ] = useState(null);
    const [ selected, setSelected ] = useState(null);

    const { options: availableOptions, default: defaultOption } = useMemo(() => {
        return giveNoteOptions(getEmail(), noteViews, value);
      }, [noteViews, value]);

      useEffect(() => {
        setSelected(defaultOption);
        setAllOptions(availableOptions);
      }, [availableOptions, defaultOption]);

    return <Box sx={{display: "flex", alignItems: "center"}}>
        {!disabled && calmTitle && <h3>Note Type: </h3>}
        {calmTitle && disabled && <Typography> Note Type: </Typography>}
        {allOptions && selected && 
            <Autocomplete
                slotProps={{
                    popupIndicator: {
                        sx: {
                            width: "fit-content"
                        }
                    }
                }}
                options={allOptions}
                value={selected}
                disabled={disabled}
                isOptionEqualToValue={(option, value) => {
                    return option.label === value;
                }}
                disableClearable
                noOptionsText={"No note types found"}
                sx={{width: "100%", py: 1}}
                onChange={(event, value) => {
                    onChange(event, value.id);
                }}
                renderOption={(props, option) => (
                    <AutocompleteOption {...props}>
                        <ListItemContent>
                            {option.label}
                            <Typography level="body-xs"
                            sx={{ color: `var(--${NoteSections.using_note_type(option.id)})` }}
                            >
                                {option.section}
                            </Typography>
                        </ListItemContent>
                    </AutocompleteOption>
                )}
            />
        }
    </Box>
}

NoteTypeSelect.propTypes = ({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    sx: PropTypes.object,
    calmTitle: PropTypes.bool,
    noteViews: PropTypes.arrayOf(PropTypes.string),
})

NoteTypeSelect.defaultProps = {
    value: null,
    disabled: false,
    calmTitle: false,
    noteViews: null,
}